import FaqLayout from "@/components/feature/FaqLayout";

export default function UnawareChargesPage() {
  return (
    <FaqLayout
      breadcrumb="/ Billing & Payments"
      title="I was unaware"
      accent="of the charges"
    >
      <div className="space-y-6 text-[#1A1C1E]">
        <h2 className="text-2xl font-bold text-[#1A1C1E]">Understanding Billing and Charges</h2>
        <p className="text-[15px] leading-relaxed text-[#4B5563]">
          Being unaware of a charge is frustrating, but it is often due to a misunderstanding of how our billing cycle works. This guide explains when and why charges occur, and what you can do if you believe a charge was made in error.
        </p>

        <h3 className="text-lg font-semibold text-[#1A1C1E] mt-8">Common Reasons for Unexpected Charges</h3>
        <ul className="list-disc list-inside space-y-3 text-[15px] leading-relaxed text-[#4B5563]">
          <li><strong>Free trial expiration:</strong> After a free trial ends, your subscription automatically converts to a paid plan unless cancelled beforehand.</li>
          <li><strong>Annual plan renewal:</strong> Annual subscriptions renew once per year, which is easy to forget about.</li>
          <li><strong>Add-on services:</strong> Additional features or upgrades may have been purchased separately.</li>
          <li><strong>Currency conversion:</strong> If you paid in a different currency, the converted amount on your statement may differ slightly.</li>
        </ul>

        <h3 className="text-lg font-semibold text-[#1A1C1E] mt-8">How to Review Your Billing History</h3>
        <p className="text-[15px] leading-relaxed text-[#4B5563]">
          Log into your Trevionix account and navigate to <strong>Account Settings → Billing History</strong>. Here you will find a complete list of all charges, including dates, amounts, and descriptions. Each charge is linked to a specific service or subscription period.
        </p>

        <h3 className="text-lg font-semibold text-[#1A1C1E] mt-8">Requesting a Refund or Dispute</h3>
        <p className="text-[15px] leading-relaxed text-[#4B5563]">
          If you believe you were charged without your knowledge or consent, you have two options:
        </p>
        <ul className="list-disc list-inside space-y-3 text-[15px] leading-relaxed text-[#4B5563] mt-3">
          <li><strong>Contact Support:</strong> For billing clarifications and refund requests within 14 days of the charge.</li>
          <li><strong>File a Dispute:</strong> For unauthorized or fraudulent charges that you did not authorize.</li>
        </ul>

        <div className="bg-[#F7F5F2] rounded-xl p-6 mt-8">
          <p className="text-sm font-semibold text-[#1A1C1E] mb-2">Prevent future surprises</p>
          <p className="text-sm text-[#6C7278]">
            Enable billing notifications in your account settings to receive an email before every renewal or charge.
          </p>
        </div>
      </div>
    </FaqLayout>
  );
}